import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Grow from '@material-ui/core/Grow';
import Fade from '@material-ui/core/Fade';
import { createGlobalStyle } from 'styled-components';
import Rellax from 'rellax';
import Magnifier from 'react-magnifier';
import { useHistory } from 'react-router-dom';
import Monospace from '../../Monospace';
import TitleSVG from './TitleSVG';
import MinervaSVG from './MinervaSVG';

const GlobalStyle = createGlobalStyle`
  body {
    transition: ${props => props.theme.transitions.create(['background-color'], { duration: 1500 })};
    background-color: ${props => props.bgColor || '#3C3737'} !important;
  }
`;

export default function RedAndGreen() {
  useEffect(() => {
    new Rellax('.rellax', { center: true, speed: -1 });
  }, []);

  const [exit, setExit] = useState(false);
  const onExit = () => setExit(true);
  const history = useHistory();
  const onExited = () => history.push('/read/exercise');

  return (
    <Grow in={!exit} direction="up" timeout={1000}>
      <Box margin="auto">
        <Fade in={!exit} timeout={1500} onExited={onExited}>
          <Box position="relative" style={{ transform: 'translateX(37px)' }}>
            <GlobalStyle bgColor={exit && '#FAF8F8'} />
            <Box className="rellax">
              <svg width="756" height="3646" viewBox="0 0 756 3646" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M368.391 1C436.403 188.227 508.669 347.358 530.613 546.333C537.278 606.763 530.805 668.284 522.836 728.556C497.924 916.962 493.065 789.511 468.169 929.333C461.462 967 466.683 970.789 474.28 999.778C475.568 1004.69 479.302 1012.21 475.058 1015C470.023 1018.31 449.49 1023.65 448.613 1023.89C417.456 1032.52 386.022 1040.69 354.28 1046.89C270.769 1063.19 185.09 1071.15 102.169 1090C90.1597 1092.73 77.3596 1090.07 65.169 1091.44C36.0491 1094.73 23.7516 1109.26 13.7245 1135.44C11.5406 1141.15 6.40807 1146.26 5.05788 1152.11C3.57303 1158.55 4.58891 1165.37 3.50232 1171.89C1.39797 1184.52 0.386401 1196.14 1.39121 1209C3.12108 1231.14 -1.33081 1256.17 5.94677 1277.44C12.6896 1297.15 39.1537 1265.45 50.2801 1261C76.102 1250.67 102.523 1253 130.391 1253C203.503 1253 277.463 1258.98 350.391 1261.78C406.043 1263.92 486.566 1267.15 545.725 1267.89C565.046 1268.13 575.413 1267.25 592.391 1264.56C606.172 1262.37 619.415 1261 633.28 1261C654.55 1261 679.577 1269.14 699.947 1274.33C703.175 1275.16 717.745 1278.08 721.058 1283.67C725.207 1290.67 722.375 1308.72 722.502 1316.11C722.667 1325.64 721.541 1340.21 725.725 1349.44C728.704 1356.02 735.583 1351.08 740.391 1353C747.184 1355.72 744.323 1396.33 744.391 1401C744.531 1410.54 745.073 1412.06 750.169 1417.89C755.621 1424.12 754.164 1444.26 754.28 1451.22C755.044 1497.07 755.108 1543.14 754.391 1589C754.319 1593.65 745.279 1591 741.836 1591.11C727.675 1591.55 715.655 1593.45 702.391 1598.56C687.416 1604.32 672.335 1609.69 667.502 1626.33C665.047 1634.79 664.657 1642.32 658.391 1649C653.808 1653.89 649.964 1667.21 641.28 1661.89C632.516 1656.52 633.281 1648 623.502 1643C597.118 1629.5 571.7 1627 542.502 1627C531.313 1627 496.464 1620.85 488.169 1632.11C477.744 1646.26 471.549 1651.06 452.502 1652.56C443.331 1653.27 433.223 1651.81 424.836 1656.56C415.583 1661.8 410.095 1665.74 399.391 1669C386.035 1673.07 374.964 1679.4 364.391 1688.56C353.607 1697.89 349.413 1700.27 334.391 1697.11C328.744 1695.92 323.388 1693.03 323.28 1700.78C323.017 1719.74 323.159 1740.22 325.28 1759C326.878 1773.15 332.329 1768.16 339.836 1775.67C343.681 1779.51 342.349 1790.29 342.391 1794.56C342.514 1806.85 342.391 1819.15 342.391 1831.44C342.391 1886.11 342.391 1940.78 342.391 1995.44C342.391 2049.68 340.238 2105.28 345.947 2158.56C349.47 2191.44 345.925 2225.77 346.836 2258.78C346.938 2262.49 344.945 2303.58 353.058 2310.11C354.07 2310.93 357.17 2306.29 357.502 2305.78C380.12 2270.82 407.12 2239.26 430.836 2205C439.893 2191.92 443.723 2185.07 460.169 2183.44C493.344 2180.17 522.296 2185.95 545.947 2211.22C557.548 2223.62 556.391 2237.7 556.391 2253.33C556.391 2280.19 556.391 2307.04 556.391 2333.89C556.391 2426.7 556.391 2519.52 556.391 2612.33C556.391 2626.02 556.641 2707.37 555.947 2731.67C555.307 2754.04 555.141 2744.13 550.169 2756.56C548.548 2760.61 550.474 2772.23 545.391 2774.11C532.552 2778.87 500.236 2754.38 492.169 2749.89C465.039 2734.77 437.411 2718.62 408.391 2707.22C401.725 2704.6 393.777 2703.18 387.725 2699.22C370.355 2687.87 356.08 2668.22 342.613 2653.11C329.425 2638.31 314.813 2614.75 297.947 2603C285.447 2594.3 264.33 2595.2 250.058 2594.22C228.12 2592.71 206.144 2593 184.169 2593C166.545 2593 146.615 2590.53 129.28 2594.33C108.303 2598.94 103.543 2628.46 101.28 2646.11C98.1016 2670.9 94.3912 2695.29 94.3912 2720.33C94.3912 2757.19 94.3912 2794.04 94.3912 2830.89C94.3912 2842.04 94.3912 2853.19 94.3912 2864.33C94.3912 2891.89 94.3912 2919.44 94.3912 2947C94.3912 2964.01 92.4717 2984.78 94.8357 3002.11C95.2453 3005.11 98.1407 3007.65 98.2801 3013.22C99.3385 3055.56 98.2162 3097.99 98.3912 3140.33C98.4721 3159.9 92.1952 3175 111.725 3175C125.962 3175 138.218 3166.91 149.836 3159.44C162.647 3151.21 190.411 3157 204.613 3157C220.114 3157 233.285 3156.9 248.169 3151.89C267.527 3145.37 287.859 3141 308.28 3141C409.476 3141 510.71 3139 611.947 3139C631.762 3139 651.576 3139 671.391 3139C684.655 3139 690.59 3138.12 700.836 3147C735.17 3176.76 732.391 3231.28 732.391 3272C732.391 3279.14 733.076 3285.59 733.947 3292.56C735.236 3302.87 675.865 3307.63 675.613 3307.67C630.881 3313.93 586.869 3315 541.947 3315C509.576 3315 477.206 3315 444.836 3315C428.57 3315 413.325 3319 397.058 3319C388.021 3319 378.984 3319 369.947 3319C358.121 3319 359.27 3320.96 355.502 3331.44C354.073 3335.42 354.439 3333.29 351.502 3335C345.14 3338.71 345.357 3348.89 344.502 3355C342.786 3367.26 340.695 3379.69 335.391 3391C325.593 3411.9 330.391 3441.86 330.391 3463.67C330.391 3509.22 330.391 3554.78 330.391 3600.33C330.391 3608.67 325.814 3632.35 330.836 3640.11C336.51 3648.88 369.049 3630.44 373.28 3628.56C389.133 3621.5 405.403 3615.6 421.391 3608.89C437.612 3602.08 453.411 3591.84 470.502 3587.44C490.764 3582.23 513.076 3581.89 533.725 3578.56C562.238 3573.95 589.615 3571 618.502 3571C643.942 3571 665.576 3570.3 689.058 3581C713.897 3592.32 725.098 3622.41 736.391 3645" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </Box>
            <Box position="absolute" top={87} left={253}>
              <TitleSVG />
            </Box>
            <Box position="absolute" textAlign="right" top={300} left={320} color="white">
              <Monospace>
                2020
                <br />
                <br />
                mixed
                <br />
                materials
              </Monospace>
            </Box>

            <Box position="absolute" top={183} left={-75}>
              <Magnifier src="/images/red-and-green/1.jpg" width={327} />
            </Box>
            <Box position="absolute" top={183} left={404}>
              <Magnifier src="/images/red-and-green/2.jpg" width={327} />
            </Box>
            <Box position="absolute" top={663} left={-75}>
              <Magnifier src="/images/red-and-green/3.jpg" width={235} />
            </Box>
            <Box position="absolute" top={697} left={222}>
              <video autoPlay muted loop width={213}>
                <source src="/video/rg_1.mp4" type="video/mp4" />
              </video>
            </Box>
            <Box position="absolute" top={899} left={222}>
              <video autoPlay muted loop width={213}>
                <source src="/video/rg_2.mp4" type="video/mp4" />
              </video>
            </Box>
            <Box position="absolute" top={916} left={496}>
              <Magnifier src="/images/red-and-green/4.jpg" width={235} />
            </Box>

            <Box position="absolute" top={1090} left={26} textAlign="center" color="white">
              <Monospace>
                The artwork is a construction where the ingredients mix and live naturally with each other: formal aspects like colours, shapes, junction of forms, patterns imitating something very familiar and different materials – all integrate with the knowledge and influences from the art historical database. The outlines exaggerate the objects and make the image look cartoonish, what adds an extra level of the relationship between the actual world and the two-dimensional & on its own authentic postiche.
              </Monospace>
            </Box>

            <Box position="absolute" top={1300} left={-75}>
              <Magnifier src="/images/red-and-green/5.jpg" width={384} />
            </Box>
            <Box position="absolute" top={1300} left={335}>
              <Magnifier src="/images/red-and-green/6.jpg" width={384} />
            </Box>

            <Box position="absolute" top={1682} left={-75}>
              <Magnifier src="/images/red-and-green/7.jpg" width={344} />
            </Box>
            <Box position="absolute" top={1682} left={395}>
              <Magnifier src="/images/red-and-green/8.jpg" width={344} />
            </Box>
            <Box position="absolute" top={2236} left={-75}>
              <Magnifier src="/images/red-and-green/9.jpg" width={453} />
            </Box>
            <Box position="absolute" top={1935} left={417}>
              <video autoPlay muted loop width={270}>
                <source src="/video/rg_3.mp4" type="video/mp4" />
              </video>
            </Box>
            <Box position="absolute" top={1995} left={-19}>
              <video autoPlay muted loop width={270}>
                <source src="/video/rg_4.mp4" type="video/mp4" />
              </video>
            </Box>
            <Box position="absolute" top={2149} left={394} display="flex" flexDirection="column">
              <Magnifier src="/images/red-and-green/1.jpg" width={86} />
              <Box height={32} />
              <Magnifier src="/images/red-and-green/1.jpg" width={86} />
              <Box height={32} />
              <Magnifier src="/images/red-and-green/1.jpg" width={86} />
            </Box>
            <Box position="absolute" top={2680} left={278}>
              <Magnifier src="/images/red-and-green/10.jpg" width={453} />
            </Box>
            <Box position="absolute" top={2611} left={171} display="flex" flexDirection="column">
              <Magnifier src="/images/red-and-green/2.jpg" width={86} />
              <Box height={32} />
              <Magnifier src="/images/red-and-green/2.jpg" width={86} />
              <Box height={32} />
              <Magnifier src="/images/red-and-green/2.jpg" width={86} />
            </Box>

            <Box width={558} textAlign="right" color="white" position="absolute" bottom={394} left={150}>
              <Monospace>
                The process of making an artwork for me consists of the previous existing works slowly evolving into something new and exiting until it becomes a part of the next following piece. Click here to see MINERVA EXERCISE I did with “Green And Red”.
              </Monospace>
            </Box>
            <Box position="absolute" bottom={345} left={315}>
              <MinervaSVG onClick={onExit} />
            </Box>

            <Box position="absolute" bottom={85} left={-75}>
              <Magnifier src="/images/red-and-green/11.jpg" width={365} />
            </Box>
            <Box position="absolute" bottom={85} left={358}>
              <Magnifier src="/images/red-and-green/12.jpg" width={365} />
            </Box>
          </Box>
        </Fade>
      </Box>
    </Grow>
  );
}
